import { SpaceBetween, spacing, styled } from '@lessonup/ui-components';
import React, { JSX } from 'react';

export interface OpenQuestionAnswerAreaContentProps {
  columns: number;
  answerCards: JSX.Element[];
  showScrollbar?: boolean;
}

export function OpenQuestionAnswerAreaContent({
  columns,
  answerCards,
  showScrollbar = false,
}: OpenQuestionAnswerAreaContentProps) {
  return (
    <StyledWrapper
      direction="x"
      spacing={spacing.size8}
      padding={spacing.size16}
      justifyContent="space-between"
      style={{
        overflowY: showScrollbar ? 'auto' : 'hidden',
      }}
    >
      {Array.from({ length: columns }).map((_, columnIndex) => (
        <StyledAnswerAreaColumn key={`column-${columnIndex}`}>
          {answerCards.map(
            (answer, answerIndex) =>
              answerIndex % columns === columnIndex && (
                <React.Fragment key={`answer-${answerIndex}`}>{answer}</React.Fragment>
              )
          )}
        </StyledAnswerAreaColumn>
      ))}
    </StyledWrapper>
  );
}

const StyledWrapper = styled(SpaceBetween)`
  width: 100%;
  height: 100%;
  scrollbar-gutter: stable;
  position: relative;
`;

const StyledAnswerAreaColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${spacing.size8};
  margin-bottom: auto;
  position: relative;
`;
